export const contextConnectedVariant = {
  props: { variant: 'contextConnected' },
  style: {
    minWidth: 0,
    width: 'fit-content',
    height: 32,
    padding: '0 12px 0 6px',
    gap: '4px',
    borderRadius: 999,
    backgroundColor: 'var(--app-context-connected-btn)',
    color: 'var(--app-context-connected-btn-fg)',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 'var(--app-font-size-body)',
    fontWeight: 'var(--app-font-weight-medium)',
    letterSpacing: 0,
    pointerEvents: 'none',
    '& .MuiButton-startIcon': { margin: 0, color: 'inherit' },
    '&:hover': { backgroundColor: 'var(--app-context-connected-btn)', boxShadow: 'none' },
  },
}
